export default {
  brandColor1: '#000000',
  complimentaryColor1: '#fff',
  brandColor2: '#000000',
  complimentaryColor2: '#fff',
};
